// extracted by mini-css-extract-plugin
export default {"otherInput":"expiry_date_modal-module___otherInput___c2a243e1"};